// src/pages/Conversations/ConversationRightDrawer.tsx
import React from "react";
import { useTheme } from "@mui/material/styles";
import ActionOnRecord from "components/Records/ActionOnRecord";
import { moveItemsBetweenNodes } from "api/Campaigns/CampaignAPI";
import { getLinkedPeopleFromInteraction } from "api/Interactions/InteractionAPI";


interface ConversationRightDrawerProps {
  conversationId: number;
}

const ConversationRightDrawer: React.FC<ConversationRightDrawerProps> = ({
  conversationId,
}) => {
  const theme = useTheme();

  // --------------------------------------------------
  // Fetch people attached to the TextMessage interaction
  // --------------------------------------------------
  const fetchPeople = async () => {
    const people = await getLinkedPeopleFromInteraction("conversation", conversationId);
    
    return people.map((p: any) => ({
      id: p.id,
      primary: `${p.first_name} ${p.last_name}`,
      secondary: p.phone_number,
    }));
  };

  // --------------------------------------------------
    // Send texts = move people forward through pathway
    // --------------------------------------------------
    const handleLogConversations = async (selected: any[]) => {
      if (!selected.length) return;
  
      await moveItemsBetweenNodes({
        item_field_name: "people",
        selected_items: selected.map(p => p.id),
        handle_name: "output-10",
        direction: "forward",
        interaction_id: conversationId,
        interaction_type: "conversation",
      });
  
    };

  return (
    <ActionOnRecord
      fetchData={fetchPeople}
      onAction={handleLogConversations}
      primaryColor={theme.custom.modules.interactions.primary.dark}
      textColor={theme.custom.base.text.primary.dark}
      actionLabel="Log Conversations"
    />
  );
};

export default ConversationRightDrawer;
